module.exports = __webpack_public_path__ + "static/media/3.39ec7b26.png";